
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { DataSet, ODataService } from '@/services'
import { RouteButton } from '@/components/buttons'
import { PageHeader } from '../components'
import { PagedDataTable, FilterText, FilterToggle } from '@/components/lists'

export default Vue.extend({
   name: 'UserList',
   props: {
      schoolId: { type: String, default: '' },
   },
   data() {
      return {
         dataset: new DataSet(new ODataService('PartyIdentityUser')),
         crumbs: [{ text: 'All Users' }] as Breadcrumb[],
         filters: {
            username: '',
            firstname: '',
            lastname: '',
         },
         columns: [
            { name: 'UserName', title: 'Username' },
            { name: 'Name', title: 'Name' },
            { name: 'DateCreated', title: 'Created', type: 'datetime' },
            { name: 'SubscriptionExpiry', title: 'Subscription Expiry', type: 'date' },
            { name: 'RoleIds', title: 'Roles', type: 'roles' },
            { name: 'IsAdminForSchool', title: 'School Admin', type: 'boolean' },
         ] as IDataTableColumn[],
      }
   },

   mounted() {
      this.dataset.filterFunction = this.filterLoadedItems
      this.dataset.sortColumn = 'UserName'
      this.dataset.query = []
      if (this.schoolId) {
         this.columns.push({ name: 'IsEnabled', title: 'Active', type: 'boolean-hide' })
         this.dataset.query.push({ name: 'schoolId', value: this.schoolId })
      }
      this.dataset.filters = [
         { name: 'UserName', comparison: 'substring', value: '' },
         { name: 'FirstName', comparison: 'substring', value: '' },
         { name: 'LastName', comparison: 'substring', value: '' },
      ]
      this.reload()
   },
   methods: {
      select(row: PartyIdentityUserDto) {
         const userId = row.Id as string
         const schoolId = this.schoolId
         this.$router.push({
            name: 'user-details',
            params: schoolId ? { userId, schoolId } : { userId },
         })
      },
      filterUsernameUpdated(value: string) {
         this.filters.username = value.trim()
      },
      filterFirstnameUpdated(value: string) {
         this.filters.firstname = value.trim()
      },
      filterLastnameUpdated(value: string) {
         this.filters.lastname = value.trim()
      },
      filterUsernameChanged(value: string) {
         this.filterUsernameUpdated(value)
         this.filterTextChanged()
      },
      filterFirstnameChanged(value: string) {
         this.filterFirstnameUpdated(value)
         this.filterTextChanged()
      },
      filterLastnameChanged(value: string) {
         this.filterLastnameUpdated(value)
         this.filterTextChanged()
      },
      filterTextChanged() {
         this.dataset.updateFilter('UserName', this.filters.username)
         this.dataset.updateFilter('FirstName', this.filters.firstname)
         this.dataset.updateFilter('LastName', this.filters.lastname)
         this.dataset.showPage(1)
         this.reload()
      },
      filterInactiveChanged(showInactive: boolean) {
         if (showInactive === true) {
            this.dataset.addQuery('enabledOnly', 'false')
         } else {
            this.dataset.removeQuery('enabledOnly')
         }
         this.dataset.showPage(1)
         this.reload()
      },
      filterLoadedItems(items: PartyIdentityUserDto[]): PartyIdentityUserDto[] {
         items.forEach(item => {
            item.IsEnabled = !!this.schoolId && item.ActiveSchoolIds.includes(this.schoolId)
         })
         return items
      },
      reload() {
         this.dataset.load()
      },
   },
   components: {
      PageHeader,
      PagedDataTable,
      FilterText,
      FilterToggle,
      RouteButton,
   },
})
